/**
 * Le LIBELLÉ d'une page, lu dans le menu filtré : la même source que le panneau
 * et que la barre, donc jamais un second jeu de noms à tenir en phase.
 *
 * Deux lecteurs à ce jour : le panneau Savoirs, qui titre « Savoirs · Effectifs »,
 * et le retour des Paramètres, qui nomme l'écran où il ramène (2026-09-18) —
 * « Revenir » seul ne disait pas où l'on revenait.
 */
export function pageLabel(nav, page, t) {
  if (!nav || !page) return null;
  for (const node of nav) {
    const items = node.items || (node.groups || []).flatMap((g) => g.items || []);
    const it = items.find((i) => i.key === page);
    if (it) return it.labelKey ? t(it.labelKey) : it.label;
  }
  /* Une BANDE qui s'ouvre sur elle-même (l'Accueil) n'a pas d'entrée d'item à
     son nom : on prend alors le nom de la bande. */
  const band = nav.find((n) => n.id === page || n.page === page);
  if (band) return band.labelKey ? t(band.labelKey) : band.label;
  return null;
}

export default pageLabel;
